export const LIKE_TYPE = Object.freeze({
  post: 'posts',
  comment: 'comments',
});

export const COMMENT_ACTION_TYPE = Object.freeze({
  create: 'create',
  delete: 'delete',
});
